import Form from '@nib-components/form';
import styled from 'styled-components';
import {p} from '@nib/layout';

const StyledForm = styled(Form)`
  ${p(0)};
`;

export default StyledForm;
